export const eulaVersion = 2;
